/**
 * Created by smizrahi on 7/27/16.
 */

import Logger from '../utils/Logger'

export default class Persistence {

    constructor(fallback = false) {
        this.fallback = fallback;
    }

    set(key, value) {
        if (this.fallback) this.setCookie(key, value);
        if (typeof(Storage) !== undefined) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {
                Logger.log('Local storage error : ');
                Logger.log(e);
            }
        } else {
            Logger.log('Local storage unsupported');
        }
    }

    get(key) {
        if (typeof(Storage) !== undefined) {
            try {
                return localStorage.getItem(key);
            } catch(e) {
                Logger.log('Local storage error : ');
                Logger.log(e);
                if (this.fallback) return this.getCookie(key);
            }
        } else {
            Logger.log('Local storage unsupported');
            if (this.fallback) return this.getCookie(key);
        }
    }

    delete(key) {
        if (typeof(Storage) !== undefined) {
            return localStorage.removeItem(key);
        } else {
            Logger.log('Local storage unsupported');
        }
    }

    setCookie(key, value) {
        var date = new Date();
        date.setTime(date.getTime()+(20*360*24*60*60*1000));
        var expires = '; expires='+date.toGMTString();

        document.cookie = key + '=' + value + expires + '; path=/';
    }

    getCookie(key) {
        var nameEQ = key + '=';
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./js/core/persistence/Persistence.js